import {AccessToken, } from "./types";
import {useMateApi} from "./useMateApi";

export interface UnprocessedDocument
{
    oid : number;
    tenant: string;
    location: string;
    terminalOid: number;
    terminal: string;
    createdAt: Date;
    modifiedAt: Date;
    error: string;
    retries: number;
    country: string;
}

export const useDiagnosticsApi = (accessToken: AccessToken) => {

    const {jsonEndpoint} = useMateApi(accessToken);
    const api = jsonEndpoint("/api/diagnostics");

    const getUnprocessedDocumentsOverview = (params?:any) => api
        .get<UnprocessedDocument[]>(params, {url: "/unprocessed-documents"});

    const unprocessedDocumentsCrudService = () => {
        const key = (entity: UnprocessedDocument) => `${entity.oid}`;
        const read = (key:string) => getUnprocessedDocumentsOverview({entityOid: key}).then(list => list?.[0]);
        const readList = () => getUnprocessedDocumentsOverview();
        return {
            key, 
            read,
            readList
        }
    }
    
    return {
        getUnprocessedDocumentsOverview,
        unprocessedDocumentsCrudService
    }
}